import { app, authentication } from "@microsoft/teams-js";

import { recordErrorInSentry } from "../../utils/init-sentry.js";

const createCallbackError = (
  operation: "success" | "failure",
  error: unknown
) =>
  new Error(
    `Failed to notify Teams popup auth ${operation}: ${
      error instanceof Error ? error.message : String(error)
    }`
  );

const initializeTeamsApp = async () => {
  await app.initialize();
};

export const notifyTeamsAuthSuccess = async (payload?: string) => {
  try {
    await initializeTeamsApp();
    authentication.notifySuccess(payload);
    return true;
  } catch (error) {
    recordErrorInSentry(createCallbackError("success", error));
    return false;
  }
};

export const notifyTeamsAuthFailure = async (reason?: string) => {
  try {
    await initializeTeamsApp();
    authentication.notifyFailure(reason);
    return true;
  } catch (error) {
    recordErrorInSentry(createCallbackError("failure", error));
    return false;
  }
};
